<template>
  <div>
    <hm-content title="商品写入pos黑名单管理">
      <div class="button-panel">
        <el-button
            type="primary"
            size="small"
            class="add-btn"
            @click="addGoods"
        >添加商品
        </el-button
        >
        <div class="ml20" style="color: red; display: inline-block;">
          添加的商品对应的订单将不会写入到POS系统
        </div>
      </div>
      <div>
        <el-input
            clearable
            style="width: 300px"
            v-model.trim="queryInfo"
            placeholder="请输入商品名称/货号查询"
            size="small"
            class="ipt mr10 mb10"
        ></el-input>
        <el-button size="small" type="primary" @click="queryList">查询</el-button>
      </div>
      <div class="inputDeep">
        <el-table :data="tableData" stripe style="width: 100%">
          <div slot="empty" style="margin-top: 118px">
            <div class="hmicon icon-a-zanwushuju2x"></div>
            <div>暂无数据</div>
          </div>
          <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="goodsName"
              label="商品名称"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="goodsSn"
              label="商品货号"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="goodsSn"
              label="操作"
          >
            <template slot-scope="scope">
              <el-button
                  @click="deleteRecord(scope.row.id)"
                  size="small"
                  class="danger"
                  type="text"
              >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
        ></el-pagination>
      </div>
    </hm-content>
    <!-- 添加商品弹窗 -->
    <el-dialog
        width="1200px"
        title="请选择微店商品"
        :visible="addGoodsDialogVisible"
        @close="addGoodsDialogVisible = false"
    >
      <div class="top-btn-wrapper flex flex-end">
        <el-select
            v-model="goodsSearchCondition.spuType"
            filterable
            placeholder="请选择微店商品分类"
            size="small"
            clearable
            class="mr10"
            @change="goGoodsSearch"
        >
          <el-option label="实物" value="reality"></el-option>
          <el-option label="虚拟" value="virtual"></el-option>
        </el-select>
        <el-select
            v-model="goodsSearchCondition.brandId"
            filterable
            placeholder="请选择商品品牌"
            size="small"
            clearable
            class="mr10"
            @change="goGoodsSearch"
        >
          <el-option
              :label="v.brandName"
              :value="v.brandId"
              v-for="(v, i) in allBrandList.records"
              :key="i"
          ></el-option>
        </el-select>
        <el-input
            clearable
            style="width: 300px"
            v-model.trim="goodsSearchCondition.keyWords"
            placeholder="请输入商品货号/关键词"
            size="small"
            class="ipt mr10 mb10"
        ></el-input>
        <el-button size="small" type="primary" @click="goGoodsSearch">查询</el-button>
      </div>
      <div class="mt20">
        <el-table
            stripe
            border
            :data="goodsList"
            style="width: 100%"
            ref="goodsTable"
        >
          <el-table-column
              type="selection"
              width="50"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="(index) => index + (goodsPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="wxshopSpuName"
              label="商品名称"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="goodsSn"
              label="商品货号"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="brandName"
              label="品牌"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="goodsListTotal"
            @current-change="goodsPaging"
            @size-change="goodsHandleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="goodsPage"
        ></el-pagination>
      </div>
      <div class="btn-wrapper flex flex-center mt20">
        <el-button size="small" type="primary" @click="goodsConfirm()"
        >确定</el-button
        >
        <el-button
            size="small"
            type="info"
            @click="addGoodsDialogVisible = false"
        >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
import { arrayUnique2 } from "@/utils/utils";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  name: "storeFinanceDayStatInfo",
  data() {
    return {
      drawer: false,
      isOutputing: false,
      // 导入失败弹窗
      errValidGoods: false,
      errInputResult: "",
      total: 0,
      searchCondition: {
        settleState: "",
        dateValue: "",
        // radioType: "manage",
      },
      queryInfo:"",
      tableData: [],
      goodsList: [],
      // 关联码列表分页
      pageSize: 10,
      currentPage: 1,
      goodsPage: 1,
      goodsSize: 10,
      goodsSearchCondition: {},
      goodsListTotal:0,
      addGoodsDialogVisible: false,
      allBrandList: []
    };
  },
  created() {
    this.queryList();
    this.queryBrandAllList();
  },
  methods: {
    // 查询列表
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      };
      if (this.queryInfo) {
        params.queryInfo = this.queryInfo;
      }
      const { result } = await this.$store.dispatch(
          "goodsWriteBlackList",
          params
      );
      const { records, total } = result;
      this.tableData = records;
      this.total = total;
    },
    // 删除接口
    async deleteRecord(rowId) {
      // 根据商品id查询
      let params = {
        id: rowId,
      };
      const { code, result } = await this.$store.dispatch(
          "goodsWriteBlackListDelete",
          params
      );
      if (code == "0") {
        this.$message({
          message: "删除成功",
          type: "success",
        });
      } else {
        this.$message({
          message: result,
          type: "warning",
        });
      }
      // 刷新微店商品管理列表
      setTimeout(() => {
        this.queryList();
      }, 1000);
    },
    // 1-追加商品,2-添加商品
    addGoods() {
      // 切换清空弹窗表格内容
      this.goodsList = [];
      this.addGoodsDialogVisible = true;
      this.queryGoods();
    },
    goGoodsSearch() {
      this.goodsPage = 1;
      this.queryGoods();
    },
    async queryGoods(){
      const { storeCode } = getLoginUser();
      let params = {
        pageNo: this.goodsPage,
        pageSize: this.goodsSize,
        storeCode: storeCode,
      };
      let queryName = "queryMicroShopGoodsList";
      Object.assign(params, this.goodsSearchCondition);
      const { result } = await this.$store.dispatch(queryName, params);
      const { records, total } = result;
      if (records) {
        this.goodsList = records;
        this.goodsListTotal = total;
      }
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    goodsPaging(page) {
      this.goodsPage = page;
      this.queryGoods();
    },
    goodsHandleSizeChange(size) {
      this.goodsPage = 1;
      this.goodsSize = size;
      this.queryGoods();
    },
    // 添加商品的确定按钮
    async goodsConfirm() {
      const selectData = this.$refs.goodsTable.selection;
      if (selectData) {
        selectData.forEach(data=>{
          data.goodsName = data.wxshopSpuName;
        })
        this.tableData = this.tableData.concat(selectData);
        // 添加去重
        this.tableData = arrayUnique2(this.tableData, "goodsSn");
        this.tableData.forEach(dv=>{
          dv.seqNum = 99;
          dv.edit_enddate = true;
        });
        this.addBlackRecord(selectData);
      }
      this.addGoodsDialogVisible = false;
    },
    addBlackRecord(selectData) {
      selectData.forEach(data=>{
        let barCode;
        if (data.goodsSnAndBarcode && data.goodsSn) {
          barCode = data.goodsSnAndBarcode.replace(data.goodsSn + "/", '');
        }
        let params = {
          goodsName: data.wxshopSpuName,
          goodsSn: data.goodsSn,
          skuId: data.wxshopSkuId,
          barCode: barCode
        };
        this.$store.dispatch(
            "addBlackRecord",
            params
        );
      })
    },
    async queryBrandAllList() {
      const { result } = await this.$store.dispatch("queryBrandAllList", {
        pageSize: 999999,
        pageNo: 1,
      });
      this.allBrandList = result;
      console.log("allBrandList");
      console.log(this.allBrandList);
    },
  },
};
</script>

<style scoped lang="scss">
.inputDeep >>> .el-input__inner {
  border: 0;
  background: none;
}
.table-panel,
.button-panel {
  margin-bottom: 20px;
}
.add-btn,
.add-goods-btn {
  margin-right: auto;
}
.inputDeep {
  min-height: 550px;
}
.el-table th.el-table__cell.is-leaf {
  color: #222222;
}
.el-table tr {
  background: #f7f7f7;
}
.el-table::before {
  height: 0;
}
.icon-a-zanwushuju2x {
  font-size: 32px;
  margin-bottom: -30px;
}
// 批量删除
.icon-shanchu1 {
  font-size: 24px;
}
.mul-delete {
  cursor: pointer;
}
.err-valid-goods-tips {
  font-weight: bold;
}
</style>
